(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-footer"] && !window.DesignMode) return;
  try {
    
  $(window).on('load',function() {
    if( $(window).width() < 768 ) {
      $('ul.ftnav-list li > .title').click(function() {
        $(this).toggleClass('active').closest('li').siblings('li').children('.title').removeClass('active');
        $(this).next('ul').slideToggle().closest('li').siblings('li').children('ul').slideUp();
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
